/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teams_Add_Member_SuccessInputs */



/**
* | output |
* | --- |
* | "Member added successfully!" |
*
* @param {Teams_Add_Member_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const teams_add_member_success = /** @type {((inputs?: Teams_Add_Member_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teams_Add_Member_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mitglied erfolgreich zum Team hinzugefügt!")
	return /** @type {LocalizedString} */ ("Member added successfully!")
});